/**
 * Copyright (c) 2023-present, Highway 9 Networks, Inc.
 */
import { Policy } from "~/types/policy";
import APIService from "./APIServices";

const policyAPI = new APIService<Policy>("applications");

export const policyService = {
  getPolicies: policyAPI.getAll,
  createPolicy: policyAPI.create,
  modifyPolicy: policyAPI.update,
  deletePolicy: policyAPI.delete,
};
